import { render, staticRenderFns } from "./DocumentSummary.vue?vue&type=template&id=49e9c5e2&"
import script from "./DocumentSummary.vue?vue&type=script&lang=js&"
export * from "./DocumentSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports